import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import PublicNavbar from '../Layout/PublicNavbar';
import PasswordInput from '../Common/PasswordInput';
import SEO from '../Common/SEO';
import { analytics } from '../../utils/analytics';
import './Auth.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const { login, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Redirect if already authenticated (unless coming from Stripe checkout)
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      // If coming from Stripe checkout, redirect to profile subscription tab
      const sessionId = searchParams.get('session_id');
      const tab = searchParams.get('tab');
      if (sessionId || tab === 'subscription') {
        navigate('/profile?tab=subscription' + (sessionId ? `&session_id=${sessionId}` : ''));
      } else {
        // Otherwise redirect to dashboard
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, authLoading, navigate, searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoginFailed(false);
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      analytics.login(result.user);
      navigate('/dashboard');
    } else {
      setError(result.error);
      setLoginFailed(true);
    }

    setLoading(false);
  };

  return (
    <>
      <SEO
        title="Login"
        description="Login to your Options Tracker account to view your options trades, performance analytics, and portfolio dashboard."
        canonicalPath="/login"
        keywords="options tracker login, options trading login, trading journal login"
        noindex={false}
      />
      <PublicNavbar />
      <div className="auth-container">
      <div className="auth-card">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          <div style={{ textAlign: 'right', marginBottom: '15px' }}>
            <Link
              to="/forgot-password"
              style={{
                fontSize: '14px',
                color: loginFailed ? 'var(--primary-color)' : 'var(--text-secondary)',
                textDecoration: 'none',
                fontWeight: loginFailed ? '600' : 'normal',
                transition: 'all 0.2s ease'
              }}
            >
              Forgot Password?
            </Link>
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p style={{ marginTop: '15px', textAlign: 'center' }}>
          Don't have an account? <Link to="/register">Register here</Link>
        </p>
      </div>
    </div>
    </>
  );
}

export default Login;

